import React from 'react';
import Swal from 'sweetalert2';
import styles from './style.module.css';

import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { InputDropdown, InputField } from '../../elements';

export default function WaterInputGroup(props) {
  const { inputListSliced, additionalInputClassname } = props;
  // console.log('water sliced', inputListSliced);

  return (
    <div className={styles.root}>
      {inputListSliced &&
        inputListSliced.map((element) => {
          // let defaultValue = '';
          // storage &&
          //   storage.forEach((localItem) => {
          //     if (
          //       parseInt(localItem.question_id) === parseInt(element.questionId)
          //     ) {
          //       defaultValue = localItem.answer;
          //     }
          //   });

          if (element.answerList) {
            return (
              <InputDropdown
                key={`dropdown-water-${element.questionId}`}
                className={`${styles.inputWater} ${additionalInputClassname}`}
                name={`inputWaterWithQuestionId${element.questionId}`}
                label={element.question}
                // defaultValue={defaultValue}
                options={element.answerList}
                required={element.required}
                onAdditionalButtonClick={(desc) => {
                  Swal.fire({
                    title: 'Deskripsi Nilai (0-3)',
                    html: desc,
                    confirmButtonText: 'Saya Mengerti',
                    confirmButtonColor: '#006CB7',
                  });
                }}
                iconButton={faCircleInfo}
                description={
                  element.description
                    ? `<p class="align-left">${element.description
                        .split('\n')
                        .join('<br/>')}</p>`
                    : 'Tidak ada rincian deskripsi'
                }
              />
            );
          } else {
            return (
              <InputField
                key={`dropdown-water-${element.questionId}`}
                className={`${styles.inputWater} ${additionalInputClassname}`}
                gan
                name={`inputWaterWithQuestionId${element.questionId}`}
                label={element.question}
                type={element.dataType}
                // defaultValue={defaultValue}
                pattern="[a-zA-Z0-9\s]+"
                required={element.required}
                // alertMessage=""
              />
            );
          }
        })}
    </div>
  );
}
